export default __webpack_public_path__ + "static/lysicrates-james-martin-paper-scroll-c8fcea19d0b81fb3f1dc5ed5abf4b484.png";